import { decode as base64_decode, encode as base64_encode } from "base-64";
import { postApi } from "../components/Utility";
import { action, makeObservable, observable } from "mobx";
import moment from "moment";
import config from "../config";
import Cookies from "js-cookie";

class AdvanceDashboardStore {
  total = 0;
  loading = false;
  counts = [];
  vehPer = [];
  jobState = [];
  fleetHours = 0;
  fuelWastage = 0;
  dayHours = 0;
  totalWorkingHrs = 0;
  nightHours = 0;
  dueCount = 0;
  overDue = 0;
  reminderDueCount = 0;
  reminderOverDue = 0;
  workinghour = [];
  MaxSpeedGraph = [];
  distanceTravelled = 0;
  avgDistperVeh = 0;
  vehicleScore = [];
  totalvehstate = [];
  MaxSpeedBars = "";
  fleetStatusArr = [];
  // trackData = []
  // totalVehicalState=[]
  // usageGraphData=[]
  // totalvehstate=[]
  // livetrack=[]

  rootStore;

  constructor(rootStore) {
    makeObservable(this, {
      loading: observable,
      counts: observable,
      vehPer: observable,
      jobState: observable,
      fleetHours: observable,
      fuelWastage: observable,
      dueCount: observable,
      overDue: observable,
      reminderDueCount: observable,
      reminderOverDue: observable,
      workinghour: observable,
      MaxSpeedGraph: observable,
      distanceTravelled: observable,
      avgDistperVeh: observable,
      vehicleScore: observable,
      totalvehstate: observable,
      MaxSpeedBars: observable,
      fleetStatusArr: observable,

      loadData: action,
      getAlertData: action,
      getFleetIdleData: action,
      getJobInfoData: action,
      getWorkingHoursData: action,
      getMaintenanceRemiderData: action,
      getRenewalRemiderData: action,
      getDistClsfctnData: action,
      exportExcel: action,
      getFleetCardsStatusData: action,
    });
    this.rootStore = rootStore;
  }

  async loadData({ companyId, vehicleStatus, userId, isadmin }) {
    // this.loading = true

    var postData = {
      companyId: companyId,
      userCompany: userId,
      status: vehicleStatus,
      isadmin: isadmin,
    };

    const base64Input = await base64_encode(JSON.stringify(postData));
    // var response = await postApi
    //   .getClient()
    //   .post(
    //     "index.php?c=vehicletracking&a=getDetailTrackDashboard",
    //     "postData=" + base64Input
    //   );

    var response = await postApi
      .getClient("NodeCoreUrl")
      .get("Dashboard/getDashboardData", {
        params: postData,
      });

    var liveTrackingData = response?.data?.data?.detailtrack;

    Object.keys(liveTrackingData).map((e, i) => {
      let r = liveTrackingData[i];

      //  var diff = new Date(r.currtime) - new Date(r.updatedate);
      const diff = moment(r.currtime).diff(r.updatedate, "minutes");
      var vehicleTypeNew = r.vehicleTypeNew.split(" ").join("-");
      if (diff >= 90) {
        liveTrackingData[i].listImage = vehicleTypeNew + "-gray.png";
        liveTrackingData[i].rowBackground = "gray";
        liveTrackingData[i].currentStatus = "nodata";
      } else if (r.acc == 1 && r.speed == 0) {
        //idle)
        liveTrackingData[i].listImage = vehicleTypeNew + "-yellow.png";
        liveTrackingData[i].rowBackground = "yellow";
        liveTrackingData[i].currentStatus = "idle";
      } else if (r.acc == 0) {
        liveTrackingData[i].listImage = vehicleTypeNew + "-red.png";
        liveTrackingData[i].rowBackground = "red";
        liveTrackingData[i].currentStatus = "stop";
      } else if (r.acc == 1 && r.speed > 0) {
        liveTrackingData[i].listImage = vehicleTypeNew + "-green.png";
        liveTrackingData[i].rowBackground = "green";
        liveTrackingData[i].currentStatus = "running";
      }
      liveTrackingData[i].mapImage = liveTrackingData[i].listImage;

      try {
        require("../assets/images/detailtracking/" +
          liveTrackingData[i].listImage);
      } catch (err) {
        liveTrackingData[i].listImage = "car-icon-blue.png";
      }

      try {
        require("../assets/images/livetracking/" +
          liveTrackingData[i].mapImage);
      } catch (err) {
        liveTrackingData[i].mapImage = "car-icon-blue.png";
      }
    });
    this.trackData = liveTrackingData;

    this.vehicalState = response?.data?.data?.totalvehstate;

    this.total = parseInt(response?.data?.data?.TotalCount);
    this.loading = false;
  }

  async getFleetCardsStatusData({ companyId, userId, isadmin, fleetStatus }) {
    // this.loading = true;
    var postData = {
      companyId: companyId,
      userId: userId,
      isadmin: isadmin,
      status: fleetStatus,
    };
    // const base64Input = await base64_encode(JSON.stringify(postData));
    // var response = await postApi
    //   .getClient()
    //   .post(
    //     "index.php?c=fleetDashboard&a=getDetailDashboardData",
    //     "postData=" + base64Input
    //   );
    var response = await postApi
      .getClient("NodeCoreUrl")
      .get("advanceDashboard/getDetailDashboardData", {
        params: postData,
      });
    var vehicleStatus = response.data?.data;

    Object.keys(vehicleStatus).map((e, i) => {
      let r = vehicleStatus[i];

      //  var diff = new Date(r.currtime) - new Date(r.updatedate);
      const diff = moment(r.currtime).diff(r.updatedate, "minutes");
      var vehicleTypeNew = r.vehicleTypeNew.split(" ").join("-");
      if (diff >= 90) {
        vehicleStatus[i].listImage = vehicleTypeNew + "-gray.png";
        vehicleStatus[i].rowBackground = "gray";
        vehicleStatus[i].currentStatus = "nodata";
      } else if (r.acc == 1 && r.speed == 0) {
        //idle)
        vehicleStatus[i].listImage = vehicleTypeNew + "-yellow.png";
        vehicleStatus[i].rowBackground = "yellow";
        vehicleStatus[i].currentStatus = "idle";
      } else if (r.acc == 0) {
        vehicleStatus[i].listImage = vehicleTypeNew + "-red.png";
        vehicleStatus[i].rowBackground = "red";
        vehicleStatus[i].currentStatus = "stop";
      } else if (r.acc == 1 && r.speed > 0) {
        vehicleStatus[i].listImage = vehicleTypeNew + "-green.png";
        vehicleStatus[i].rowBackground = "green";
        vehicleStatus[i].currentStatus = "running";
      }
      vehicleStatus[i].mapImage = vehicleStatus[i].listImage;

      try {
        require("../assets/images/detailtracking/" +
          vehicleStatus[i].listImage);
      } catch (err) {
        vehicleStatus[i].listImage = "car-icon-blue.png";
      }

      try {
        require("../assets/images/livetracking/" + vehicleStatus[i].mapImage);
      } catch (err) {
        vehicleStatus[i].mapImage = "car-icon-blue.png";
      }
    });
    this.fleetStatusArr = vehicleStatus;
  }

  async getAlertData({ companyId, userId, isadmin, offset, limit }) {
    this.loading = true;
    var postData = {
      companyId: companyId,
      userId: userId,
      isadmin: isadmin,
      offset: 0,
      limit: 50,
    };
    // const base64Input = await base64_encode(JSON.stringify(postData));
    // var response = await postApi
    //   .getClient()
    //   .post(
    //     "index.php?c=fleetDashboard&a=alertCounts",
    //     "postData=" + base64Input
    //   );
    var response = await postApi
      .getClient("NodeCoreUrl")
      .get("advanceDashboard/alertCounts", {
        params: postData,
      });
    this.counts = response.data?.data?.counts;
    this.vehPer = response.data?.data?.vehPer;
  }

  async getFleetIdleData({ companyId, userId, isadmin, offset, limit }) {
    var postData = {
      companyId: companyId,
      userId: userId,
      isadmin: isadmin,
      offset: 0,
      limit: 50,
    };
    // const base64Input = await base64_encode(JSON.stringify(postData));
    // var response = await postApi
    //   .getClient()
    //   .post(
    //     "index.php?c=fleetDashboard&a=fleetIdle",
    //     "postData=" + base64Input
    //   );
    var response = await postApi
      .getClient("NodeCoreUrl")
      .get("advanceDashboard/fleetIdle", {
        params: postData,
      });
    this.fleetHours = response.data?.data?.fleetHours;
    this.fuelWastage = response.data?.data?.fuelWastage;
  }

  async getJobInfoData({ companyId, userId, isadmin, offset, limit }) {
    var postData = {
      companyId: companyId,
      userId: userId,
      isadmin: isadmin,
      offset: 0,
      limit: 50,
    };
    // const base64Input = await base64_encode(JSON.stringify(postData));
    // var response = await postApi
    //   .getClient()
    //   .post("index.php?c=fleetDashboard&a=jobInfo", "postData=" + base64Input);
    var response = await postApi
      .getClient("NodeCoreUrl")
      .get("advanceDashboard/jobInfo", {
        params: postData,
      });
    this.jobState = response?.data?.data?.jobState;
  }

  async getWorkingHoursData({ companyId, userId, isadmin, offset, limit }) {
    var postData = {
      companyId: companyId,
      userId: userId,
      isadmin: isadmin,
      offset: 0,
      limit: 50,
    };
    // const base64Input = await base64_encode(JSON.stringify(postData));
    // var response = await postApi
    //   .getClient()
    //   .post(
    //     "index.php?c=fleetDashboard&a=workingHours",
    //     "postData=" + base64Input
    //   );
    var response = await postApi
      .getClient("NodeCoreUrl")
      .get("advanceDashboard/workingHour", {
        params: postData,
      });

    this.dayHours = response.data?.data?.dayHours;
    this.totalWorkingHrs = response.data?.data?.totalWorkingHrs;
    this.nightHours = response.data?.data?.nightHours;
  }

  async getMaintenanceRemiderData({
    companyId,
    userId,
    isadmin,
    offset,
    limit,
  }) {
    var postData = {
      companyId: companyId,
      userId: userId,
      isadmin: isadmin,
      offset: 0,
      limit: 50,
    };
    // var base64Input = await base64_encode(JSON.stringify(postData));
    // var response = await postApi
    //   .getClient()
    //   .post(
    //     "index.php?c=fleetDashboard&a=maitenanceReminder",
    //     "postData=" + base64Input
    //   );
    var response = await postApi
      .getClient("NodeCoreUrl")
      .get("advanceDashboard/maitenanceReminder", {
        params: postData,
      });
    this.dueCount = response?.data?.data?.dueCount;
    this.overDue = response?.data?.data?.overdue;
  }
  async getRenewalRemiderData({ companyId, userId, isadmin, offset, limit }) {
    var postData = {
      companyId: companyId,
      userId: userId,
      isadmin: isadmin,
      offset: 0,
      limit: 50,
    };
    // var base64Input = await base64_encode(JSON.stringify(postData));
    // var response = await postApi
    //   .getClient()
    //   .post(
    //     "index.php?c=fleetDashboard&a=renewalReminder",
    //     "postData=" + base64Input
    //   );
    var response = await postApi
      .getClient("NodeCoreUrl")
      .get("advanceDashboard/renewalReminder", {
        params: postData,
      });
    this.reminderDueCount = response?.data?.data?.dueCount;
    this.reminderOverDue = response?.data?.data?.overdue;
  }

  async getDistClsfctnData({ companyId, userId, isadmin, offset, limit }) {
    var postData = {
      companyId: companyId,
      userId: userId,
      isadmin: isadmin,
      offset: 0,
      limit: 50,
    };
    // var base64Input = await base64_encode(JSON.stringify(postData));
    // var response = await postApi
    //   .getClient()
    //   .post(
    //     "index.php?c=fleetDashboard&a=distanceClassification",
    //     "postData=" + base64Input
    //   );
    var response = await postApi
      .getClient("NodeCoreUrl")
      .get("advanceDashboard/distanceClassification", { params: postData });
    this.workinghour = response?.data?.data?.workinghour;
  }

  async getMaxSpeedData({ companyId, isadmin, offset, limit }) {
    var postData = {
      companyId: companyId,
      type: "maxspeed",
      isadmin: isadmin,
      userId: JSON.parse(base64_decode(Cookies.get("data"))).userId,
      offset: 0,
      limit: 50,
      fleetMAxSpeedGraph: 1,
    };
    // var base64Input = await base64_encode(JSON.stringify(postData));
    // var response = await postApi
    //   .getClient()
    //   .post(
    //     "index.php?c=fleetDashboard&a=maxSpeedGraph",
    //     "postData=" + base64Input
    //   );
    if (config.pythonReport === 1) {
      var response = await postApi
        .getClient("report")
        .post("/graph/maxspeedGraph", postData);
    } else {
      response = await postApi
        .getClient("NodeCoreUrl")
        .get("advanceDashboard/maxSpeedGraph", { params: postData });
    }

    this.MaxSpeedGraph = response?.data?.data?.MaxSpeedGraph;
    this.distanceTravelled = response?.data?.data?.distanceTravelled;
    this.avgDistperVeh = response?.data?.data?.avgDistperVeh;

    var root = document.documentElement;
    var MaxSpeedBars = Object.keys(this.MaxSpeedGraph).map((e, i) => {
      let r = this.MaxSpeedGraph[i];
      var cnt = i + 1;

      var MaxSpeedPrcnt = (r.maxSpeed * 100) / 240;
      root.style.setProperty("--changeMS" + cnt, MaxSpeedPrcnt + "%");
      var vehclass = "";
      var length = r.vehNo?.length;

      if (length > 15) {
        vehclass = "vehicleNum-20";
      } else if (length > 11) {
        vehclass = "vehicleNum-15";
      } else if (length > 7) {
        vehclass = "vehicleNum-8";
      } else if (length > 4) {
        vehclass = "vehicleNum-5";
      }

      return (
        <div class="bar-row">
          <span>
            <div class={`prog${cnt}`}>
              <div class="divprog-bar progress-moved">
                <div class={`divprog-bar${cnt}`}></div>
              </div>
            </div>
          </span>
          <strong class={vehclass}>{r.vehNo}</strong>
        </div>
      );
    });

    this.MaxSpeedBars = MaxSpeedBars;
  }

  async getVehScoreData({ companyId, userId, isadmin, offset, limit }) {
    var postData = {
      companyId: companyId,
      userId: userId,
      isadmin: isadmin,
      offset: 0,
      limit: 50,
    };

    // var base64Input = await base64_encode(JSON.stringify(postData));
    // var response = await postApi
    //   .getClient()
    //   .post(
    //     "index.php?c=fleetDashboard&a=vehicleScore",
    //     "postData=" + base64Input
    //   );

    var response = await postApi.getClient('report').post("/graph/vehicleScoreGraph", postData);
    // var response = await postApi
    //   .getClient("NodeCoreurl")
    //   .get("advanceDashboard/vehicleScoreGraph", { params: postData });


    var VehicleScoreGraphData = response?.data?.data?.vehicleScore;

    if (VehicleScoreGraphData) {
      VehicleScoreGraphData.forEach((element) => {
        element.acccount = Number(element.acccount);
        element.brakecount = Number(element.brakecount);
        element.speedcount = Number(element.speedcount);
      });

      this.vehicleScore = VehicleScoreGraphData;
    }

    this.loading = false;
  }

  async getFleetStatusData({ companyId, userId, isadmin, offset, limit }) {
    var postData = {
      companyId: companyId,
      userId: userId,
      isadmin: isadmin,
      offset: 0,
      limit: 50,
    };
    var base64Input = await base64_encode(JSON.stringify(postData));
    // var response = await postApi
    //   .getClient()
    //   .post(
    //     "index.php?c=vehicletracking&a=getLiveRouteData",
    //     "postData=" + base64Input
    //   );
    var response = await postApi
      .getClient("NodeCoreUrl")
      .get("Dashboard/getLiveRouteData", {
        params: postData,
      });
    this.totalvehstate = response?.data?.data?.totalvehstate;

    var running = this.totalvehstate?.Moving;
    var Idle = this.totalvehstate?.Idle;
    var Stopped = this.totalvehstate?.Stopped;
    var NoData = this.totalvehstate?.NoData;
    var expired = this.totalvehstate?.expired;
    var total = this.totalvehstate?.TotalVehCount;
    var expired = this.totalvehstate?.expired;

    var RunningPrcnt = (running * 100) / total;
    var StoppedPrcnt = (Stopped * 100) / total;
    var IdlePrcnt = (Idle * 100) / total;
    var NoDataPrcnt = (NoData * 100) / total;
    // var InActivePrcnt = (expired * 100) / total;
    var InActivePrcnt = (expired * 100) / (parseInt(total) + parseInt(expired));

    var root = document.documentElement;
    root.style.setProperty("--change2", RunningPrcnt + "%");
    root.style.setProperty("--change3", StoppedPrcnt + "%");
    root.style.setProperty("--change4", IdlePrcnt + "%");
    root.style.setProperty("--change5", NoDataPrcnt + "%");
    root.style.setProperty("--change6", InActivePrcnt + "%");
  }

  async exportExcel(getData) {
    let lang = "english";
    var postData = {
      companyId: getData.cid,
      userId: getData.userId,
      isadmin: getData.isadmin,
      status: getData.vehicleStatus,
      colList: getData.colList,
      vehicleNo: getData.vehicleNo,
    };
    // window.location.href =
    //   baseURL +
    //   "index.php?c=fleetDashboard&a=fleetStatusExcel&cid=" +
    //   getData.cid +
    //   "&userId=" +
    //   getData.userId +
    //   "&isadmin=" +
    //   getData.isadmin +
    //   "&vNo=" +
    //   "" +
    //   "&status=" +
    //   getData.vehicleStatus +
    //   "&colList=" +
    //   getData.colList +
    //   "&language=" +
    //   lang;
    try {
      const response = await postApi.getClient("NodeCoreUrl").post(
        "Dashboard/exportFleetStatusExcel",
        { postData },
        {
          responseType: "blob",
        }
      );

      const blob = new Blob([response.data], {
        type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
      });
      const link = document.createElement("a");
      link.href = window.URL.createObjectURL(blob);
      link.download = "Vehicle_Data_Excel.xlsx";

      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    } catch (error) {
      console.error("Error downloading the file", error);
    }
  }

  // async exportPowerExcel(getData) {
  //   console.log("getData", getData);
  //   let lang = "english";
  //   window.location.href =
  //     baseURL +
  //     "index.php?c=fleetDashboard&a=getDetailDashboardDataExcel&cid=" +
  //     getData.cid +
  //     "&userId=" +
  //     getData.userId +
  //     "&isadmin=" +
  //     getData.isadmin +
  //     "&vNo=" +
  //     "" +
  //     "&status=" +
  //     getData.fleetStatus +
  //     "&colList=" +
  //     getData.colList +
  //     "&language=" +
  //     lang;
  // }
  async exportPowerExcel(getData) {
    try {
      var response = await postApi
        .getClient("NodeCoreUrl")
        .post("advanceDashboard/getDetailDashboardDataExcel", getData, {
          responseType: "blob",
        });
      const blob = new Blob([response.data], {
        type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
      });
      const link = document.createElement("a");
      link.href = window.URL.createObjectURL(blob);
      link.download = getData.fleetStatus + ".xlsx";

      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    } catch (error) {
      console.error("Error downloading the file", error);
    }
  }
}

export default AdvanceDashboardStore;
